import { inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAuthenticatedUser } from '../+state/auth.selectors';
import { AuthenticatedUser } from '../models/authenticated-user.model';

export const injectAuthenticatedUser = () =>
  inject(Store).selectSignal(
    selectAuthenticatedUser,
  ) as Signal<AuthenticatedUser>;
